import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlycorporatecabrentalinhyderabad() {



  const cardData =
  {
    keyword: 'Monthly Corporate Cab Rentals in Hyderabad',
    heading: 'Aaryan Travels: Monthly Corporate Cab Rentals in Hyderabad',
    headingDescription: 'Aaryan Travels provides reliable Monthly Corporate Cab Rentals in Hyderabad for IT companies, industrial units, and business professionals who need consistent and punctual transportation. Whether it’s for daily employee commute, executive travel, airport transfers from Rajiv Gandhi International Airport, or intercity meetings to Bangalore or Vijayawada, our fleet of sedans, SUVs, and tempo travellers is available on fixed monthly contracts with flexible billing. With trained chauffeurs, GPS-enabled cars, on-time reporting, and 24/7 support, we ensure smooth mobility across major corporate zones like HITEC City, Gachibowli, Banjara Hills, and Kukatpally. Aaryan Travels simplifies business travel with efficient long-term corporate cab rental solutions in Hyderabad.',

    top: 'Top Places to Visit in Hyderabad with Aaryan Travels',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Built in 1591 by Sultan Muhammad Quli Qutb Shah, Charminar is Hyderabad’s most iconic landmark with four grand minarets and stunning Indo-Islamic architecture. Surrounded by lively bazaars like Laad Bazaar, it is famous for bangles, pearls, and street snacks. Illuminated beautifully at night, it becomes a spectacular sight. Charminar is Hyderabad’s timeless symbol of culture and heritage."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a majestic hilltop fortress known for its powerful acoustic system and royal legacy. Once home to legendary diamonds like Kohinoor and Hope, it showcases strong architecture, massive gates, and scenic viewpoints. The evening sound-and-light show narrates its glorious history. Golconda Fort is Hyderabad’s monumental pride of strength and monarchy."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City, the world’s largest film studio complex, offers movie set tours, adventure rides, and live performances. From royal palaces to railway stations, it recreates multiple cinematic worlds. Families enjoy carnival parades, stunt shows, and themed attractions. Ramoji Film City is Hyderabad’s ultimate entertainment kingdom."
  },
  {
    "title": "Hussain Sagar Lake & Buddha Statue",
    "description": "Hussain Sagar is a heart-shaped lake connecting Hyderabad and Secunderabad. At its center stands a 58-foot monolithic Buddha statue on a rock island. Boat rides during sunset offer mesmerizing skyline views. The surrounding Necklace Road is perfect for evening strolls and street eats. Hussain Sagar is Hyderabad’s peaceful waterfront delight."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest art museums featuring global collections by Mir Yousuf Ali Khan, Salar Jung III. Highlights include the Veiled Rebecca statue and the famous musical clock. The galleries house paintings, weapons, carpets, and antiques from around the world. Salar Jung Museum is Hyderabad’s artistic treasure trove."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a beautiful white marble temple dedicated to Lord Venkateswara, located atop Naubat Pahad hill. The temple offers panoramic views of the city and Hussain Sagar Lake. Its peaceful ambiance and detailed carvings attract devotees and tourists alike. Lit up at night, it looks divine. Birla Mandir is Hyderabad’s beacon of devotion and serenity."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace was the official residence of the Nizams, showcasing elegant courtyards, Belgian chandeliers, and vintage cars. The Khilwat Mubarak hall is the grandest attraction. Visitors explore regal galleries and lush gardens. Cultural events and photoshoots are often held here. Chowmahalla Palace is Hyderabad’s royal testimony to luxury and legacy."
  },
  {
    "title": "Mecca Masjid",
    "description": "Mecca Masjid, built using soil from Mecca, is one of the largest mosques in India. Its grand domes, sprawling courtyard, and peaceful surroundings attract visitors from all faiths. Thousands attend prayers daily, especially on Fridays. Pigeons fluttering around add charm. Mecca Masjid is Hyderabad’s serene sanctuary of spirituality."
  },
  {
    "title": "Laad Bazaar",
    "description": "Laad Bazaar, located near Charminar, is famous for lacquer bangles, pearls, and bridal accessories. Narrow lanes filled with colorful shops and aroma of kebabs create a festive shopping experience. Bargaining is a must here. Laad Bazaar is Hyderabad’s vibrant marketplace of tradition and trends."
  },
  {
    "title": "Nehru Zoological Park",
    "description": "Nehru Zoological Park is one of India’s largest zoos, home to tigers, lions, elephants, and exotic birds. Safari rides and toy trains make it a thrilling experience for families. The lush greenery and educational displays offer a refreshing outing. Nehru Zoo is Hyderabad’s wild escape into nature."
  }
],


"services": [
  {
    "name": "Monthly Corporate Cab Rentals in Hyderabad",
    "description": "Monthly Corporate Cab Rentals in Hyderabad provide businesses with dependable and flexible transportation solutions tailored for long-term corporate needs. Our service includes a diverse fleet of premium vehicles driven by professional chauffeurs, ensuring timely, comfortable, and safe rides for employees and clients. With customizable plans, businesses can manage their travel budgets efficiently while enjoying seamless service that adapts to evolving corporate schedules and requirements."
  },
  {
    "name": "Hyderabad Corporate Monthly Cab Hire",
    "description": "Hyderabad Corporate Monthly Cab Hire offers corporate clients dedicated monthly cab rentals with a focus on professionalism, punctuality, and safety. Our vehicles are regularly maintained, and our chauffeurs are trained to provide courteous, discreet service that aligns with corporate standards."
  },
  {
    "name": "Business Cab Subscription Hyderabad",
    "description": "Business Cab Subscription Hyderabad is designed to simplify recurring corporate transportation needs by offering flexible subscription models. Companies can ensure consistent availability of quality cabs, reduce administrative overhead, and enhance employee commute experiences through reliable monthly services."
  },
  {
    "name": "Chauffeur Corporate Cab Hyderabad Monthly",
    "description": "Chauffeur Corporate Cab Hyderabad Monthly delivers premium chauffeur-driven cars for businesses requiring elegant and efficient transportation. Our drivers are well-versed in corporate etiquette and local routes, ensuring a smooth, professional travel experience every time."
  },
  {
    "name": "Office Transport Hyderabad Monthly",
    "description": "Office Transport Hyderabad Monthly specializes in monthly transport solutions tailored for employee commutes. This service focuses on timely pickups and drop-offs, safety, and comfort, helping companies ensure workforce punctuality and satisfaction."
  },
  {
    "name": "Staff Cab Hyderabad Monthly",
    "description": "Staff Cab Hyderabad Monthly provides affordable and reliable monthly cab services for company staff. Featuring a range of vehicles to accommodate various group sizes, this service is designed to streamline employee transportation with consistent quality and safety standards."
  },
  {
    "name": "Corporate Taxi Hyderabad Monthly",
    "description": "Corporate Taxi Hyderabad Monthly offers businesses the convenience of monthly taxi rentals with professional drivers. Our service prioritizes reliability, cleanliness, and efficient scheduling to support your company’s transportation needs."
  },
  {
    "name": "Corporate Vehicle Rental Hyderabad",
    "description": "Corporate Vehicle Rental Hyderabad features a versatile fleet of vehicles suited for various corporate travel demands. With options ranging from sedans to SUVs, our rentals come with trained drivers and flexible rental durations to accommodate short-term or extended use."
  },
  {
    "name": "Executive Corporate Cab Hyderabad",
    "description": "Executive Corporate Cab Hyderabad is tailored for senior executives seeking premium, chauffeur-driven transportation. Our luxury vehicles and professional drivers ensure discretion, punctuality, and a comfortable environment conducive to work or relaxation during transit."
  },
  {
    "name": "Affordable Monthly Corporate Cab Hyderabad",
    "description": "Affordable Monthly Corporate Cab Hyderabad delivers cost-effective corporate transportation solutions without compromising on quality or professionalism. Transparent pricing and flexible packages make this service an excellent choice for budget-conscious businesses."
  },
  {
    "name": "Corporate Car Leasing Hyderabad",
    "description": "Corporate Car Leasing Hyderabad provides long-term leasing options for companies requiring dedicated vehicles for employee transportation. Our leasing plans include maintenance, insurance, and driver services, offering a hassle-free alternative to short-term rentals."
  },
  {
    "name": "Online Corporate Cab Hyderabad",
    "description": "Online Corporate Cab Hyderabad enables businesses to effortlessly book and manage monthly corporate cab services through a user-friendly digital platform. Features include instant booking confirmation, real-time ride tracking, and easy access to invoices and reports for efficient transportation management."
  },
  {
    "name": "Monthly Business Cab Hyderabad",
    "description": "Monthly Business Cab Hyderabad caters to organizations needing reliable, consistent business travel solutions. Our service ensures well-maintained vehicles and professional drivers are always available to meet your corporate commuting and business event requirements."
  },
  {
    "name": "Long Term Corporate Cab Hyderabad",
    "description": "Long Term Corporate Cab Hyderabad offers extended rental agreements designed for companies with ongoing transportation demands. This service provides cost savings, priority support, and consistent high-quality vehicles and drivers to support long-term business operations."
  },
  {
    "name": "Corporate Transport Hyderabad",
    "description": "Corporate Transport Hyderabad delivers comprehensive corporate travel solutions including employee commutes, client transfers, and event transportation. With a focus on professionalism, safety, and punctuality, our service adapts to diverse corporate requirements for a smooth and efficient travel experience."
  }
],
"tableData": [
  ["Monthly Corporate Cab Rentals in Hyderabad", "Hyderabad Corporate Monthly Cab Hire"],
  ["Business Cab Subscription Hyderabad", "Chauffeur Corporate Cab Hyderabad Monthly"],
  ["Office Transport Hyderabad Monthly", "Staff Cab Hyderabad Monthly"],
  ["Corporate Taxi Hyderabad Monthly", "Corporate Vehicle Rental Hyderabad"],
  ["Executive Corporate Cab Hyderabad", "Affordable Monthly Corporate Cab Hyderabad"],
  ["Corporate Car Leasing Hyderabad", "Online Corporate Cab Hyderabad"],
  ["Monthly Business Cab Hyderabad", "Long Term Corporate Cab Hyderabad"],
  ["Corporate Transport Hyderabad", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Monthly Corporate Cab Rentals in Hyderabad",
    "WhyChoosedescription": "Aaryan Travels provides reliable monthly corporate cab rentals in Hyderabad for seamless business commuting."
  },
  {
    "WhyChooseheading": "Punctual and Professional Drivers",
    "WhyChoosedescription": "Our experienced chauffeurs ensure timely pickups and drop-offs to keep your corporate schedule on track."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cars maintained for your comfort and safety throughout the rental period."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Hyderabad Routes",
    "WhyChoosedescription": "Our drivers know Hyderabad’s roads well to provide efficient and smooth rides."
  },
  {
    "WhyChooseheading": "Transparent Monthly Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy fixed monthly rates covering fuel, tolls, and driver allowances for hassle-free billing."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Corporate Clients",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings and inquiries."
  },
  {
    "WhyChooseheading": "Customizable Plans to Fit Your Business Needs",
    "WhyChoosedescription": "Choose from various plans and vehicle types tailored to your corporate travel requirements."
  },
  {
    "WhyChooseheading": "Priority Service and Dedicated Fleet",
    "WhyChoosedescription": "Benefit from priority booking and a dedicated fleet for uninterrupted corporate travel."
  }
]














  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer monthly corporate cab rentals in Hyderabad?',
    answer: 'Yes, Aaryan Travels provides flexible and reliable monthly corporate cab rental plans in Hyderabad designed to meet your business travel needs.',
  },
  {
    question: 'How can I book monthly corporate cab rentals in Hyderabad with Aaryan Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our dedicated 24x7 corporate customer support team.',
  },
  {
    question: 'What types of vehicles are available for monthly corporate rentals in Hyderabad?',
    answer: 'Aaryan Travels offers a variety of vehicles including sedans, SUVs, and premium cars tailored for corporate travel.',
  },
  {
    question: 'Are drivers experienced and trained for corporate cab services in Hyderabad?',
    answer: 'Absolutely. Our drivers are licensed, punctual, and trained to navigate Hyderabad routes efficiently and safely.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for monthly corporate cab rentals?',
    answer: 'Yes, pickup and drop-off points can be customized anywhere within Hyderabad and its surrounding business areas.',
  },
  {
    question: 'Is the monthly corporate cab rental service available 24x7 in Hyderabad?',
    answer: 'Yes, Aaryan Travels operates round-the-clock to accommodate your business schedules and shift timings.',
  },
  {
    question: 'Are safety and hygiene protocols followed for monthly corporate cab services?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene protocols.',
  },
  {
    question: 'What payment options are accepted for monthly corporate cab rentals in Hyderabad?',
    answer: 'We accept payments through corporate accounts, UPI, digital wallets, credit/debit cards, and bank transfers.',
  },
  {
    question: 'Is customer support available during the rental period?',
    answer: 'Yes, our 24x7 customer support team is always ready to assist you throughout the rental duration.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vikram Reddy',
    feedback: 'Aaryan Travels’ monthly corporate cab rental service in Hyderabad has streamlined our employee transportation efficiently.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Swathi Narayan',
    feedback: 'Reliable and professional monthly corporate cab service by Aaryan Travels in Hyderabad. Highly recommend for businesses!',
    rating: 5,
  },
];


























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];





const monthlyCorporateCabHyderabadSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Monthly Corporate Cab Rentals in Hyderabad",
  "description": "Aaryan Travels provides affordable monthly corporate cab rentals in Hyderabad, including chauffeur-driven executive and staff transportation services.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Hyderabad"
  },
  "serviceType": "Monthly Corporate Cab Rental Service",
  "keywords": "Monthly Corporate Cab Rentals in Hyderabad, Hyderabad Corporate Monthly Cab Hire, Business Cab Subscription Hyderabad, Chauffeur Corporate Cab Hyderabad Monthly, Office Transport Hyderabad Monthly, Staff Cab Hyderabad Monthly, Corporate Taxi Hyderabad Monthly, Corporate Vehicle Rental Hyderabad, Executive Corporate Cab Hyderabad, Affordable Monthly Corporate Cab Hyderabad, Corporate Car Leasing Hyderabad, Online Corporate Cab Hyderabad, Monthly Business Cab Hyderabad, Long Term Corporate Cab Hyderabad, Corporate Transport Hyderabad"
};









  return (
    <div>
<Helmet>
  <title>Monthly Corporate Cab Rentals in Hyderabad | Executive & Staff Transport | Aaryan Travels</title>
  <meta
    name="description"
    content="Book monthly corporate cab rentals in Hyderabad with chauffeur-driven executive and staff transport services by Aaryan Travels. Affordable and reliable."
  />
  <meta
    name="keywords"
    content="Monthly Corporate Cab Rentals in Hyderabad, Hyderabad Corporate Monthly Cab Hire, Business Cab Subscription Hyderabad, Chauffeur Corporate Cab Hyderabad Monthly, Office Transport Hyderabad Monthly, Staff Cab Hyderabad Monthly, Corporate Taxi Hyderabad Monthly, Corporate Vehicle Rental Hyderabad, Executive Corporate Cab Hyderabad, Affordable Monthly Corporate Cab Hyderabad, Corporate Car Leasing Hyderabad, Online Corporate Cab Hyderabad, Monthly Business Cab Hyderabad, Long Term Corporate Cab Hyderabad, Corporate Transport Hyderabad"
  />
  <script type="application/ld+json">
    {JSON.stringify(monthlyCorporateCabHyderabadSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/65.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlycorporatecabrentalinhyderabad;